module.exports = __webpack_public_path__ + "static/media/teaser-der-abend-kompakt.129653ff.jpg";